import { render, staticRenderFns } from "./postil.vue?vue&type=template&id=0f99c1dc&scoped=true&"
import script from "./postil.vue?vue&type=script&lang=js&"
export * from "./postil.vue?vue&type=script&lang=js&"
import style0 from "./postil.vue?vue&type=style&index=0&id=0f99c1dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f99c1dc",
  null
  
)

export default component.exports